import React from 'react';
import SafeIcon from '../common/SafeIcon';

const AiExplanation = ({ selectedItems, type }) => {
  if (selectedItems.length === 0) return null;

  const generateExplanation = () => {
    const pointsList = selectedItems.map(i => `${i.label} (${i.points > 0 ? '+' : ''}${i.points})`).join(', ');
    
    return `Com base nos critérios assinalados, o paciente acumulou pontos devido a fatores de risco e sinais clínicos específicos: ${pointsList}. 
    
    A presença de fatores como imobilização, malignidade ou histórico prévio aumentam o risco basal de eventos tromboembólicos. Sinais agudos (como taquicardia em TEP ou edema assimétrico em TVP) refletem a resposta fisiológica ou a obstrução venosa mecânica. O julgamento clínico (diagnósticos alternativos) ajusta a probabilidade com base na avaliação médica global. 
    
    Lembre-se: Este é um cálculo de probabilidade pré-teste (escore de Wells). O resultado orienta o próximo passo no algoritmo diagnóstico (como solicitar Dímero-D ou exame de imagem), mas não confirma nem exclui de forma isolada a presença de tromboembolismo.`;
  };

  return (
    <div className="bg-indigo-50 border border-indigo-100 rounded-lg p-5 mt-6 shadow-sm">
      <div className="flex items-center gap-2 mb-3 text-indigo-800 font-semibold">
        <SafeIcon name="Cpu" className="text-xl" />
        <h3>Análise Assistida por IA (Simulada)</h3>
      </div>
      <p className="text-sm text-indigo-900 leading-relaxed text-justify">
        {generateExplanation()}
      </p>
      <div className="mt-3 text-xs text-indigo-700 bg-indigo-100/50 p-2 rounded">
        <strong>Aviso:</strong> A IA apenas explica a pontuação baseada em padrões. A decisão clínica deve ser sempre do médico assistente.
      </div>
    </div>
  );
};

export default AiExplanation;
